// extracted by mini-css-extract-plugin
module.exports = {"upgradeSlide":"_2-XGEg","content":"_19Jhsh"};